<template>
  <div :class="[success ? 'alert-success' : 'alert-danger']"
       class="alert alert-dismissible fade show w-100"
       :style="{ 'display': display }" role="alert">
    {{text}}
    <button type="button" class="btn-close"
            @click="resetDisplay"
            aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>

<script>

export default {
  name: 'Alert',
  methods: {
    resetDisplay() {
      this.$emit(this.type);
    },
  },
  // Paramètres de l'alerte
  props: {
    display: String,
    success: Boolean,
    text: String,
    type: String,
  },
};
</script>
